"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var I18n = require("i18n-js");
var refund_request_1 = require("./refund_request");
var RefundRequestDetails = function (props) {
    if (props.userType === refund_request_1.IUserType.BUYER || !props.refundRequest.isPersisted) {
        return null;
    }
    var returnShippingLabelCost;
    if (props.order.returnShippingLabelAmount) {
        returnShippingLabelCost = (React.createElement("div", { className: "form-group" },
            React.createElement("div", { className: "form-group__header" },
                React.createElement("label", null, I18n.t('discovery.dashboard.refundRequests.returnShippingLabelCost'))),
            React.createElement("div", { className: "form-group__fields" },
                React.createElement("p", { className: "mb-0" }, props.order.returnShippingLabelAmount.display))));
    }
    var noteToSeller;
    if (props.refundRequest.noteToSeller) {
        noteToSeller = (React.createElement("div", { className: "form-group" },
            React.createElement("div", { className: "form-group__header" },
                React.createElement("label", null, I18n.t('discovery.dashboard.refundRequests.noteFromBuyer'))),
            React.createElement("div", { className: "form-group__fields" },
                React.createElement("p", { className: "mb-0" }, props.refundRequest.noteToSeller))));
    }
    return (React.createElement("div", { className: "scaling-mb-2" },
        React.createElement("div", { className: "form-group" },
            React.createElement("div", { className: "form-group__header" },
                React.createElement("label", null, I18n.t('discovery.dashboard.refundRequests.seller.reason.label'))),
            React.createElement("div", { className: "form-group__fields" },
                React.createElement("p", { className: "mb-0" }, I18n.t("discovery.dashboard.refundRequests.seller.reasons." + props.refundRequest.reason)))),
        returnShippingLabelCost,
        noteToSeller));
};
exports.default = RefundRequestDetails;
//# sourceMappingURL=refund_request_details.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/refund_requests/refund_request_details.js
// module id = Ks2t
// module chunks = 20 21